import { z } from "zod";
import { safeParse } from "../../../lib/zod";
import { ControlDefinition, serialize } from "../../definition";
import {
  DTOSchema,
  richTextDAOToDTO,
  richTextDTOtoDAO,
  richTextDTOtoSelection
} from "../dto";
import { copyRichTextData } from "./copy";
import { introspectRichTextData } from "./introspection";
class Definition extends ControlDefinition {
  static type = "makeswift::controls::rich-text";
  static get schema() {
    const type = z.literal(this.type);
    const data = DTOSchema.valueJSON;
    const value = data;
    const definition = z.object({
      type
    });
    return {
      type,
      data,
      value,
      definition
    };
  }
  constructor() {
    super({});
  }
  get controlType() {
    return Definition.type;
  }
  get schema() {
    const baseSchema = Definition.schema;
    return {
      ...baseSchema,
      resolvedValue: this.nodeSchema
    };
  }
  get nodeSchema() {
    return z.any();
  }
  safeParse(data) {
    return safeParse(this.schema.data, data);
  }
  fromData(data) {
    return data;
  }
  toData(value) {
    return value;
  }
  copyData(data, context) {
    return copyRichTextData(data, context);
  }
  serialize() {
    return serialize(this.config, {
      type: Definition.type
    });
  }
  introspect(data, target) {
    return introspectRichTextData(data, target);
  }
  static nodesToData(children, selection) {
    return richTextDAOToDTO(children, selection);
  }
  static dataToNodes(data) {
    return richTextDTOtoDAO(data);
  }
  static dataToSelection(data) {
    return richTextDTOtoSelection(data);
  }
}
export {
  Definition as RichTextV1Definition
};
//# sourceMappingURL=rich-text.js.map